import { render, staticRenderFns } from "./ProductSearch.vue?vue&type=template&id=21b8566e&scoped=true&lang=pug&"
import script from "./ProductSearch.vue?vue&type=script&lang=ts&"
export * from "./ProductSearch.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSearch.vue?vue&type=style&index=0&id=21b8566e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b8566e",
  null
  
)

export default component.exports